import * as React from "react";
import { Routes, Route } from "react-router-dom";


import './App.css';

import Home from './pages/home/index';
import MyBooking from './pages/myBooking/index'
import MyAccount from './pages/account/index'
import ProfileVerification from './pages/Profileverification/index'
import DocumentUpload from './pages/Documentupload/index'
import VerifiedDocument from './pages/verifieddocuments/index'
import AboutUs from './pages/aboutus'
import CarBookingList from "./pages/carbookinglist";
import CarBookingCheckout from "./pages/carbookingcheckout/carBookingCheckout";
import FareSummary from "./pages/faresummary/index"
import CompletedBooking from "./pages/completedbooking";
import PaymentSummary from "./pages/paymentsummary/index";
import TermsConditions from "./pages/terms&conditions/index";
import AccountDetails from "./pages/createprofile/index"
import Faq from "./pages/faq/index";
import Credits from "./pages/credits/index";
import AddMoney from "./pages/addmoney";
import AddNewMethod from "./pages/addnewcarddetail/index";
import Codriver from "./pages/codriver/index";
import PolicyContent from "./pages/policies/index";
import ContactUs from "./pages/contactus/index";
import Help from "./pages/help/index";
import SavedCard from "./pages/savedcard";
import AddNetBanking  from "./pages/addnetbanking/index";
import AddDebitCard from "./pages/adddebitcard";
import GoToTop from "./components/GoToTop";

function App() {
  return (
    <>
    
    
    <Routes>
       {/* <Routes basename='/'>  */}
        {/* <Route path={`${process.env.PUBLIC_URL}/`} component={<Home />} />
        <Route path={`${process.env.PUBLIC_URL}/mybooking`} component={<MyBooking />} />
        <Route path={`${process.env.PUBLIC_URL}/myaccount`} component={<MyAccount />} />
        <Route path={`${process.env.PUBLIC_URL}/profileverification`} component={<ProfileVerification />} />
        <Route path={`${process.env.PUBLIC_URL}/documentupload`} component={<DocumentUpload />} />
        <Route path={`${process.env.PUBLIC_URL}/verifieddocument`} component={<VerifiedDocument/>} />
        <Route path={`${process.env.PUBLIC_URL}/aboutus`} component={<AboutUs/>} />
        <Route path={`${process.env.PUBLIC_URL}/carbookinglist`} component={<CarBookingList/>} />
        <Route path={`${process.env.PUBLIC_URL}/carbookingcheckout`} component={<CarBookingCheckout/>} />
        <Route path={`${process.env.PUBLIC_URL}/faresummary`} component={<FareSummary/>} />
        <Route path={`${process.env.PUBLIC_URL}/completedbooking`} component={<CompletedBooking/>} />
        <Route path={`${process.env.PUBLIC_URL}/paymentsummary`} component={<PaymentSummary/>} />
        <Route path={`${process.env.PUBLIC_URL}/termsconditons`} component={<TermsConditions/>} /> 
        <Route path={`${process.env.PUBLIC_URL}/createprofile`} component={<AccountDetails/>} /> 
        <Route path={`${process.env.PUBLIC_URL}/faq`} component={<Faq/>} /> 
        <Route path={`${process.env.PUBLIC_URL}/credits`} component={<Credits/>} /> 
        <Route path={`${process.env.PUBLIC_URL}/addmoney`} component={<AddMoney/>} /> 
        <Route path={`${process.env.PUBLIC_URL}/addnewmethod`} component={<AddNewMethod/>} /> 
        <Route path={`${process.env.PUBLIC_URL}/codriver`} component={<Codriver/>} /> 
        <Route path={`${process.env.PUBLIC_URL}/policycontent`} component={<PolicyContent/>} /> 
        <Route path={`${process.env.PUBLIC_URL}/contactus`} component={<ContactUs/>} /> 
        <Route path={`${process.env.PUBLIC_URL}/help`} component={<Help/>} /> 
        <Route path={`${process.env.PUBLIC_URL}/savedcard`} component={<SavedCard />} /> 
        <Route path={`${process.env.PUBLIC_URL}/addnetbanking`} component={<AddNetBanking  />} /> 
        <Route path={`${process.env.PUBLIC_URL}/adddebitcard`} component={<AddDebitCard  />} />  */}

        <Route path="/" element={<Home />} />
        <Route path="/mybooking" element={<MyBooking />} />
        <Route path="/myaccount" element={<MyAccount />} />
        <Route path="/profileverification" element={<ProfileVerification />} />
        <Route path="/documentupload" element={<DocumentUpload />} />
        <Route path="/verifieddocument" element={<VerifiedDocument/>} />
        <Route path="/aboutus" element={<AboutUs/>} />
        <Route path="/carbookinglist" element={<CarBookingList/>} />
        <Route path="/carbookingcheckout" element={<CarBookingCheckout/>} />
        <Route path="/faresummary" element={<FareSummary/>} />
        <Route path="/completedbooking" element={<CompletedBooking/>} />
        <Route path="/paymentsummary" element={<PaymentSummary/>} />
        <Route path="/termsconditons" element={<TermsConditions/>} /> 

        <Route path="/createprofile" element={<AccountDetails/>} /> 
        <Route path="/faq" element={<Faq/>} /> 
        <Route path="/credits" element={<Credits/>} /> 
        <Route path="/addmoney" element={<AddMoney/>} /> 
        <Route path="/addnewmethod" element={<AddNewMethod/>} /> 
        <Route path="/codriver" element={<Codriver />} /> 
        <Route path="/policycontent" element={<PolicyContent />} /> 
        <Route path="/contactus" element={<ContactUs />} /> 
        <Route path="/help" element={<Help />} /> 
        <Route path="/savedcard" element={<SavedCard />} /> 
        <Route path="/addnetbanking" element={<AddNetBanking />} /> 
        <Route path="/adddebitcard" element={<AddDebitCard />} />  
  
    </Routes>
       <GoToTop />

    </>
);
}

export default App;